// extracted by css-extract-rspack-plugin
export default {"code":"M0_pwxZKk3sMIpzp","small":"BEvluE1b35YO0GwH","medium":"fju50wTVxNs2WrTp"};